
<template>
	<!-- <div>
		Home
	</div> -->
    <section class="container">
        <div class="columns is-multiline">
            <div class="column is-8 is-offset-2 register">
                <div class="columns">
                    <div class="column left">
                        <img :src="require('../../assets/images/logo_cts.jpg')" alt="logo" class="logo">    
                        <h2 class="subtitle colored is-4">Bienvenid@</h2>
                        <p>Si ya está registrado/a. </p>
                        <router-link tag="a" :to="{name: 'auth.login'}">Ingresar al sitio</router-link>
                        <br />
                        <br />
                        <p>¿Primera vez que ingresás?</p>
                        <router-link tag="a" :to="{name: 'auth.register'}">Generar un usuario y contraseña</router-link>
                        <br />
                        <br />
                        <p>¿Olvidaste tu contraseña?</p>
                        <router-link tag="a" :to="{name: 'auth.recover'}">Recuperar contraseña</router-link>
                        <br />
                        <br />
                        <a href="http://tssantafesur.org.ar/">Volver a la Web del Colegio</a>
                    </div>

                    <transition name="fade" mode="out-in">
                        <router-view/>
                    </transition>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: 'AuthView',
}
</script>

<style>
    :root {
        --brandColor: hsl(166, 67%, 51%);
        --background: rgb(247, 247, 247);
        --textDark: hsla(0, 0%, 0%, 0.66);
        --textLight: hsla(0, 0%, 0%, 0.33);
    }

    body {
        background: var(--background);
        color: var(--textDark);
    }

    .field:not(:last-child) {
        margin-bottom: 1rem;
    }

    .register {
        margin-top: 4rem;
        background: white;
        border-radius: 10px;
    }

    .left,
    .right {
        padding: 4.5rem;
    }

    .left {
        border-right: 5px solid var(--background);
    }

    .left .title {
        font-weight: 800;
        letter-spacing: -2px;
    }

    .left .colored {
        color: var(--brandColor);
        font-weight: 500;
        margin-top: 1rem !important;
        letter-spacing: -1px;
    }

    .left p {
        color: var(--textLight);
        font-size: 1.15rem;
    }

    .right .title {
        font-weight: 800;
        letter-spacing: -1px;
    }

    .right .description {
        margin-top: 1rem;
        margin-bottom: 1rem !important;
        color: var(--textLight);
        font-size: 1.15rem;
    }

    .right small {
        color: var(--textLight);
    }

    input {
        font-size: 1rem;
    }

    input:focus {
        border-color: var(--brandColor) !important;
        box-shadow: 0 0 0 1px var(--brandColor) !important;
    }

    .fab,
    .fas {
        color: var(--textLight);
        margin-right: 1rem;
    }

</style>